<template>
    <div  class="app-main" id="transport-index">
        <el-row type="flex" class="app-main-header" align="middle">
            <el-col :span="6">
                <div class="router-title">
                    <i class="el-icon-s-home"></i><span style="margin-left: 5px;">{{$route.meta.title}}</span>
                </div>
            </el-col>
        </el-row>
        <el-card class="box-card mg-b5">
            <div class="el-menu-box">
                <el-menu :default-active="activeIndex" mode="horizontal" @select="handleSelect">
                    <el-menu-item
                        v-for="item in menus"
                        :key="item.key"
                        :index="item.key">
                            {{item.name}}
                    </el-menu-item>
                </el-menu>
            </div>
        </el-card>
        <div class="order-wrap">
            <orderTable :pageFlag = 'activeIndex' />
        </div>
    </div>
</template>

<script>
import orderTable from './orderTable'
export default {
    components: {
        orderTable
    },
    data() {
        return {
            activeIndex:'',
            menus:[],
        };
    },
    computed: {

    },
    created() {
        console.log(this.$route)
    },
    mounted() {
        this.initPage()
    },
    methods: {
        initPage(){
            let fullPath = this.$route.fullPath;
            this.activeIndex = '';
             this.menus = [
                {key:'all',name:'全部'},
            ]
            this.activeIndex = 'all'
        },
        handleSelect(key){
            this.activeIndex = key;
        },
    },

    watch: {
        $route:function(nVal){
            this.initPage()
        }
    },
};
</script>

<style lang="scss">

</style>
